import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'Импорт',
      title: 'Импорт',
      executeAction: 'Отправить',
      errorMessage: 'Ошибка',
      successMessage: 'Все %{count} строки добавлены',
      addedItemsCount: 'Добавлено строк',
      errorItems: 'Ошибки',
      fields: {
      },
    }
  }
}